<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator">
            <div class="control-block-left">
                <div class="flex">
                    <p class="btn-back caption-help margin-right-10">
                        <router-link :to="$route.query.returnUrl ? $route.query.returnUrl : ('/projects/' + $route.params.projectId)">Проект</router-link>
                    </p>
                    <p class="caption-help margin-right-10">
                        Роли
                    </p>
                </div>
            </div>
        </div>

        <div class="body-panel-content body-panel-content-page">
            <div class="profile-edit block-in-page">
                <div class="profile-roles">
                    <Container @drop="onDrop" :lock-axis="'y'">
                        <Draggable v-for="(role, i) of rolesOrdered">
                            <div class="draggable-item" @dblclick="onRoleEdit(role)" @click="onRoleSelect(role)">
                                <template v-if="role.Edited">
                                    <input type="text" class="input-text"
                                           v-model="role.Name"
                                           @click.stop=""
                                           @change="onNameChange(role)"/>
                                </template>
                                <template v-if="!role.Edited">
                                    {{ role.Name }}
                                    <div class="btns flex" style="float:right;margin-top:-6px">
                                        <button class="btn btn-default btn-img" @click.stop="onRoleEdit(role)">
                                            <img src="../../img/pencil-edit-button.png" alt="" />
                                        </button>
                                        <button class="btn btn-default btn-img" @click.stop="removeRole(role, i)">
                                            <img src="../../img/icon-del.png" alt="" />
                                        </button>
                                    </div>
                                </template>
                            </div>
                        </Draggable>
                    </Container>
                    <button class="btn margin-top-10" @click.stop="addNew">Добавить</button>
                </div>
            

                <div class="profile-setting">
                    <template v-if="roleSelected">
                        <p class="panel-block-header">{{roleSelected.Name}}</p>
                        <p class="caption-help">Параметры роли</p>
                        <ul class="hidden-list margin-top-15">

                            <li v-for="claim of claims.filter(x => {return x.GroupId === 1 && x.Id !== claimEnums.mainPageSettings && x.Id !== claimEnums.reportAdd })">
                                <input class="input-checkbox" type="checkbox"
                                       :id="'claim' + claim.Id"
                                       :value="bindClaim(claim, getRoleClaim(roleSelected, claim.Id))"
                                       v-model="roleSelected.Claims"
                                       :disabled="claim.Id === claimEnums.newRepliesNotification && !isTasksControllerSelected"
                                       @change="onClaimChange(roleSelected, claim)" />
                                <label :for="'claim' + claim.Id" class="input-checkbox-lbl">{{claim.Name}}</label>
                            </li>
                        </ul>
                        <div class="line-separator"></div>
                        <p class="caption-help">Доступ к меню</p>
                        <ul class="hidden-list margin-top-15">
                            <li v-for="claim of claims.filter(x => {return x.GroupId === 2 || x.Id === claimEnums.reportAdd;})">
                                <input class="input-checkbox" type="checkbox"
                                       :id="'claim' + claim.Id"
                                       :value="bindClaim(claim, getRoleClaim(roleSelected, claim.Id))"
                                       v-model="roleSelected.Claims"
                                       @change="onClaimChange(roleSelected)" />
                                <label :for="'claim' + claim.Id" class="input-checkbox-lbl">{{claim.Name}}</label>
                                <input class="input-text" type="text"
                                       v-if="claim.HasValue && getRoleClaim(roleSelected, claim.Id) != null"
                                       v-model="getRoleClaim(roleSelected, claim.Id).Value"
                                       @input="onClaimChange(roleSelected)" />
                            </li>
                        </ul>
                        <div class="line-separator"></div>

                        <p class="caption-help">Стартовая страница</p>
                        <!--пока только так, слишком кастомно получается-->
                        <div style="position:relative">
                            <drop-down :items="pages"
                                       :dataField="'Path'"
                                       :textField="'Name'"
                                       v-model="getRoleClaim(roleSelected, mainPageSettingsClaim.Id).Value"
                                       v-if="getRoleClaim(roleSelected, mainPageSettingsClaim.Id) != null"
                                       @change="onClaimChange(roleSelected)"></drop-down>
                        </div>

                        <div class="line-separator"></div>

                        <div v-if="isRatingSelected">
                            <p class="caption-help">Настройка рейтингов</p>

                            <div class="form-field">
                                <label class="input-text-lbl">Поля адресной программы</label>
                                <drop-down :items="tradePointFields"
                                           :dataField="'Id'"
                                           :textField="'Name'"
                                           v-model="roleSelected.RatingSettings.TradePointField"
                                           @change="onClaimChange(roleSelected)"></drop-down>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">Кол-во на странице</label>
                                <input type="text" class="input-text"
                                       v-model="roleSelected.RatingSettings.PageSize"
                                       @change="onClaimChange(roleSelected)">
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">Рейтинг по-умолчанию</label>
                                <drop-down :items="project.RatingRoles"
                                           :dataField="'Value'"
                                           :textField="'Name'"
                                           :withSelectItem="'true'"
                                           v-model="roleSelected.RatingSettings.DefaultProjectRatingRole"
                                           @change="onClaimChange(roleSelected)"></drop-down>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

        </div>

        <vue-headful title="Роли" />
    </div>
</template>

<script>
    import { Container, Draggable } from "vue-smooth-dnd"
    import _ from 'lodash'
    import BackendApi from '../backendApi'
    import $ from 'jquery'
    import UI from '../helpers/ui-helpers'
    import projectMixin from '../helpers/project-mixin'

    let backendApi = new BackendApi();

    export default {
        name: "roles",

        mixins: [projectMixin], // projectId

        components: { Container, Draggable },

        data(){
            return {
                project: null,
                roles: [],
                claims: [],
                pages:[
                    {Path:'', Name: 'Выбрать'},
                    {Path:'/projects', Name: 'Проекты'},
                    {Path:'/news', Name: 'Новости'},
                    {Path:'/materials', Name: 'Материалы'},
                    {Path:'/reports', Name: 'Отчёты'},
                    {Path:'/rating', Name: 'Рейтинг'},
                    {Path:'/spend-bonuses', Name: 'Потратить бонусы'},
                    {Path:'/analytics', Name: 'Аналитика'},
                    {Path:'/sku', Name: 'SKU'},
                    {Path:'/motivation', Name: 'Программа мотивации'},
                    {Path:'/faq', Name: 'Faq'},
                    {Path:'/my-progress', Name: 'Мои достижения'}],
                tradePointFields: [
                    {Id: '', Name: 'Без ограничений'},
                    {Id: '[Name]', Name: 'Наименование'},
                    {Id: '[Region]', Name: 'Область'},
                    {Id: '[City]', Name: 'Город'},
                    {Id: '[ExternalId]', Name: 'Внешний идентификатор'},
                    {Id: '[SkuLink]', Name: 'Связь sku'}
                ]
            }
        },

        computed: {
            isTasksControllerSelected() {
                return this.roleSelected && this.roleSelected.Claims.some(claim => claim.ClaimId === this.claimEnums.tasksController);
            },

            rolesOrdered: function () {
                return _.orderBy(this.roles, 'Order');
            },

            roleSelected: function () {
                let selected =  this.roles.filter((r) => r.Selected);
                return selected.length ? selected[0]: null;
            },

            mainPageSettingsClaim(){
                return this.claims.find(x => { return x.Id === this.claimEnums.mainPageSettings });
            },

            isRatingSelected() {
                let selectedRole = this.roleSelected;
                if (selectedRole != null) {
                    return selectedRole.Claims.find(x => x.ClaimId === this.claimEnums.ratingPage) != null;
                }
                return false;
            }
        },

        methods: {
            bindClaim(claim, roleClaim){
                return {
                    ClaimId: claim.Id,
                    Value: roleClaim ? roleClaim.Value : null
                }
            },

            getRoleClaim(role, claimId){
                return role.Claims.find((val) => val.ClaimId === claimId);
            },

            load() {
                let vm = this;
                UI.blockUI('.dataContent', 'Загрузка...');
                this.callApiWrapper(backendApi.rolesList(vm.$route.params.projectId))
                    .then(function (resp) {
                        UI.unblockUI('.dataContent');
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки ролей');
                        }
                        else {
                            if (resp.data) {
                                resp.data.Roles.forEach((r) => {
                                    r.Edited = false;
                                    r.Selected = false;

                                    let mainPageSettingsClaim = r.Claims.find((val) => val.ClaimId === vm.claimEnums.mainPageSettings);
                                    if(mainPageSettingsClaim === undefined){
                                        r.Claims.push({
                                            ClaimId: vm.claimEnums.mainPageSettings,
                                            Value: null
                                        })
                                    }
                                    if(r.RatingSettings == null){
                                        r.RatingSettings = {};
                                    }
                                });

                                vm.roles = resp.data.Roles;
                                vm.claims = resp.data.Claims;
                                // [{DynamicRoleId: 5, TradePointField: '[City]', PageSize: 10}];//resp.data.ratingSettings;
                            }
                        }
                    });
            },

            loadProject() {
                let vm = this;
                let id = parseInt(vm.$route.params.projectId);
                return backendApi.projectLoad(id).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке проекта');
                    } else {
                        let data = response.data;
                        vm.project=data;
                    }
                });
            },

            saveRole(role) {
                let vm = this;

                UI.blockUI('.portlet', 'Сохранение...');
                let saveObj = Object.assign({}, role, {
                    ProjectId: vm.$route.params.projectId
                });

                this.callApiWrapper(backendApi.rolesSave(saveObj)).then(function (response) {
                    //console.info('rolesSave -> response', response);
                    UI.unblockUI('.portlet');
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при сохранении роли');
                    } else {
                        UI.toastr.success('Успешно сохранено');
                        //console.info('response.data', response.data)

                        role.Id = response.data;
                    }
                });
            },

            saveRoles(roles) {
                let vm = this;

                UI.blockUI('.portlet', 'Сохранение...');
                let saveObj = [];
                for(let role of roles){
                    saveObj.push(Object.assign({}, role, {
                        ProjectId: vm.$route.params.projectId
                    }))
                }

                backendApi.rolesSaveList(saveObj).then(function (response) {
                    //console.info('rolesSave -> response', response);
                    UI.unblockUI('.portlet');
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при сохранении роли');
                    } else {
                        UI.toastr.success('Успешно сохранено');
                    }
                });
            },

            removeRole(role, index){
                let vm = this;
                if(role.Id > 0) {
                    UI.blockUI('.portlet', 'Удаление...');

                    backendApi.rolesDelete(role.Id).then(function (response) {
                        //console.info('rolesSave -> response', response);
                        UI.unblockUI('.portlet');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении роли');
                        } else {
                            UI.toastr.success('Успешно удалено');
                        }

                        let indexRemove;
                        for(let i = 0; i< vm.roles.length; i++){
                            if(vm.roles[i].Order === role.Order){
                                indexRemove = i;
                                break;
                            }
                        }
                        vm.roles.splice(indexRemove, 1);
                    });
                }
                else{
                    let indexRemove;
                    for(let i = 0; i< vm.roles.length; i++){
                        if(vm.roles[i].Order === role.Order){
                            indexRemove = i;
                            break;
                        }
                    }
                    vm.roles.splice(indexRemove, 1);
                }
            },

            onNameChange(role){
                this.saveRole(role);
            },

            onClaimChange: _.debounce(function (role, claim) {

                if(claim !== undefined){

                    // проверяем чтобы одна роль не могла иметь права на добавление и проверку отчёта
                    if(claim.Id === this.claimEnums.reportAdd){
                        for(let i = 0; i < role.Claims.length; i++){
                            if(role.Claims[i].ClaimId === this.claimEnums.reportCheck){
                                role.Claims.splice(i, 1);
                                break;
                            }
                        }

                    }else if(claim.Id === this.claimEnums.reportCheck){
                        for(let i = 0; i < role.Claims.length; i++){
                            if(role.Claims[i].ClaimId === this.claimEnums.reportAdd){
                                role.Claims.splice(i, 1);
                                break;
                            }
                        }
                    }

                    if(claim.Id === this.claimEnums.mainPageSettings){
                        for(let i = 0; i < role.Claims.length; i++){
                            if(role.Claims[i].ClaimId === this.claimEnums.mainPageSettings && role.Claims[i] === ''){
                                role.Claims.splice(i, 1);
                                break;
                            }
                        }
                    }

                    if (claim.Id === this.claimEnums.ttAccess || claim.Id === this.claimEnums.tasksEdit) {
                        let i_ttAccess = -1;
                        let i_taskEdit = -1;
                        for (let i = 0; i < role.Claims.length; i++) {
                            if (role.Claims[i].ClaimId === this.claimEnums.ttAccess) i_ttAccess = i;
                            if (role.Claims[i].ClaimId === this.claimEnums.tasksEdit) i_taskEdit = i;
                        }
                        if (i_ttAccess < 0 && i_taskEdit > -1) role.Claims.splice(i_taskEdit, 1);
                    }

                    // Новая проверка
                    if (claim.Id === this.claimEnums.tasksController) {
                        if (!role.Claims.some(c => c.ClaimId === this.claimEnums.tasksController)) {
                            // Если "Контролер заданий" отключен, то отключаем "Уведомление о новых ответах"
                            for(let i = 0; i < role.Claims.length; i++){
                                if(role.Claims[i].ClaimId === this.claimEnums.newRepliesNotification){
                                    role.Claims.splice(i, 1);
                                    break;
                                }
                            }
                        }
                    }
                }

                this.saveRole(role);

            }, 800),

            onRoleEdit(role){
                this.roles.forEach((r) => {
                    r.Edited = false;
                });
                role.Edited = true;
            },

            onRoleSelect(role){
                this.roles.forEach((r) => {
                    r.Selected = false;
                });
                role.Selected = true;
            },

            addNew(){
                let vm = this;
                let maxOrder = 1;
                this.roles.forEach((r) => {
                    if(r.Order > maxOrder){
                        maxOrder = r.Order;
                    }
                    r.Edited = false;
                });

                this.roles.push({Id: 0,
                    Name: 'Новая роль',
                    ProjectId: vm.projectId,
                    Order: ++maxOrder,
                    Edited: true,
                    Selected: true,
                    Claims: [],
                    RatingSettings:{}
                });
            },

            onDrop(dropResult){
                let vm = this;

                if(dropResult.removedIndex === dropResult.addedIndex){
                    return;
                }

                let rolesTemp = _.orderBy(vm.roles, 'Order');
                let itemToAdd;
                if (dropResult.removedIndex != null) {
                    itemToAdd = rolesTemp.splice(dropResult.removedIndex, 1)[0];
                }
                if (dropResult.addedIndex !== null) {
                    rolesTemp.splice(dropResult.addedIndex, 0, itemToAdd)
                }

                let order = 1;
                rolesTemp.forEach((role) => {
                    role.Order = order++;
                });

                vm.roles = rolesTemp;

                this.saveRoles(this.roles);
            }
        },

        mounted() {
            let vm = this;

            Promise.all([vm.loadProject(), vm.load()]);

            vm.$nextTick(() => {

                $('body').on('click', function () {
                    vm.roles.forEach((role) => {
                        role.Edited = false;
                    })
                });

            });
        },

        destroyed() {
            $('body').off('click');
        }
    }
</script>



// WEBPACK FOOTER //
// Content/src/views/Roles.vue